import moment from 'moment';

export default function TableConfig(getColumnSearchProps) {
  return {
    columns: [
      {
        dataIndex: 'id',
        title: '№/ id',
        ...getColumnSearchProps('id', 'номер/id очереди'),
      },
      {
        dataIndex: 'name',
        title: 'Очередь/услуга',
        ...getColumnSearchProps('name', 'наименование очереди'),
      },
      {
        dataIndex: 'idle_operators',
        title: 'Кол-во операторов',
        sorter: (a, b) => a.idle_operators - b.idle_operators,
      },
      {
        dataIndex: 'cnt_clean',
        title: 'В изначальной очереди',
        sorter: (a, b) => a.cnt_clean - b.cnt_clean,
      },
      {
        dataIndex: 'max_initial_wait',
        title: 'Максимальное время ожидания в изначальной очереди',
        render: (cell, row) => moment.utc(row.max_initial_wait * 1000).format('HH:mm:ss'),
        sorter: (a, b) => a.max_initial_wait - b.max_initial_wait,
      },
      {
        dataIndex: 'cnt_dirty',
        title: 'Ожидание решения',
        sorter: (a, b) => a.cnt_dirty - b.cnt_dirty,
      },
      {
        dataIndex: 'max_secondary_wait',
        title: 'Максимальное время ожидания решения',
        render: (cell, row) => moment.utc(row.max_secondary_wait * 1000).format('HH:mm:ss'),
        sorter: (a, b) => a.max_secondary_wait - b.max_secondary_wait,
      },
    ],
  };
}
